exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-1bd7f21a] {\n  width: 100%;\n}\n", ""]);

// exports
